const OrdersRoutes = {
  getOrders: "/admin/getOrder",
  getOrderDetail: "/admin/getOrderDetail-by-order-id/",
  getFilteredOrder: "/admin/getOrder-by-emailname",
  orderStatus: "/admin/update-order-status/",
};

export default OrdersRoutes;
